/**
 * Generates Tab data object to avoid code duplications and briging potential
 * inconsitencies across multiple components.
 *
 *     {
 *         label: 'Matches',
 *         link: '/football/spain/la-liga'
 *     }
 *
 * @param  {String} label   Tab label
 * @param  {String} link    Tab link
 * @return {Object}         Tab data
 */
export const generateTabData = (label, link) => ({
    label,
    link,
});
